// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__3LNUR","Success":"Button_Success__2kwfo","Danger":"Button_Danger__1LTyR"};